import { Constants } from "./constants";

const ElementRunningTimes: any = {
  [Constants.sanctioning_club.AKC]: {
    [Constants.show_type.rally_obedience]: {
      [Constants.dog_class_element_level.novice_a]:
        Constants.running_order_times.AKC.rally_obedience.novice_a,
      [Constants.dog_class_element_level.novice_b]:
        Constants.running_order_times.AKC.rally_obedience.novice_b,
      [Constants.dog_class_element_level.intermediate]:
        Constants.running_order_times.AKC.rally_obedience.intermediate,
      [Constants.dog_class_element_level.advanced_a]:
        Constants.running_order_times.AKC.rally_obedience.advanced_a,
      [Constants.dog_class_element_level.advanced_b]:
        Constants.running_order_times.AKC.rally_obedience.advanced_b,
      [Constants.dog_class_element_level.excellent_a]:
        Constants.running_order_times.AKC.rally_obedience.excellent_a,
      [Constants.dog_class_element_level.excellent_b]:
        Constants.running_order_times.AKC.rally_obedience.excellent_b,
      [Constants.dog_class_element_level.master]:
        Constants.running_order_times.AKC.rally_obedience.master,
      [Constants.dog_class_element_level.choice]:
        Constants.running_order_times.AKC.rally_obedience.choice,
      [Constants.dog_class_element_level.pairs]:
        Constants.running_order_times.AKC.rally_obedience.pairs,
      [Constants.dog_class_element_level.team]:
        Constants.running_order_times.AKC.rally_obedience.team,
    },
    [Constants.show_type.obedience]: {
      [Constants.dog_class_element_level.pre_novice]:
        Constants.running_order_times.AKC.obedience.pre_novice,
      [Constants.dog_class_element_level.beginner_novice]:
        Constants.running_order_times.AKC.obedience.beginner_novice,
      [Constants.dog_class_element_level.beginner_novice_a]:
        Constants.running_order_times.AKC.obedience.beginner_novice_a,
      [Constants.dog_class_element_level.beginner_novice_b]:
        Constants.running_order_times.AKC.obedience.beginner_novice_b,
      [Constants.dog_class_element_level.preferred_novice]:
        Constants.running_order_times.AKC.obedience.preferred_novice,
      [Constants.dog_class_element_level.novice_a]:
        Constants.running_order_times.AKC.obedience.novice_a,
      [Constants.dog_class_element_level.novice_b]:
        Constants.running_order_times.AKC.obedience.novice_b,
      [Constants.dog_class_element_level.novice_c]:
        Constants.running_order_times.AKC.obedience.novice_c,
      [Constants.dog_class_element_level.advance_novice]:
        Constants.running_order_times.AKC.obedience.advance_novice,
      [Constants.dog_class_element_level.graduate_novice]:
        Constants.running_order_times.AKC.obedience.graduate_novice,
      [Constants.dog_class_element_level.open_a]:
        Constants.running_order_times.AKC.obedience.open_a,
      [Constants.dog_class_element_level.open_b]:
        Constants.running_order_times.AKC.obedience.open_b,
      [Constants.dog_class_element_level.advance_open]:
        Constants.running_order_times.AKC.obedience.advance_open,
      [Constants.dog_class_element_level.preferred_open]:
        Constants.running_order_times.AKC.obedience.preferred_open,
      [Constants.dog_class_element_level.graduate_open]:
        Constants.running_order_times.AKC.obedience.graduate_open,
      [Constants.dog_class_element_level.utility_a]:
        Constants.running_order_times.AKC.obedience.utility_a,
      [Constants.dog_class_element_level.utility_b]:
        Constants.running_order_times.AKC.obedience.utility_b,
      [Constants.dog_class_element_level.preferred_utility]:
        Constants.running_order_times.AKC.obedience.preferred_utility,
      [Constants.dog_class_element_level.wc_novice]:
        Constants.running_order_times.AKC.obedience.wc_novice,
      [Constants.dog_class_element_level.wc_open]:
        Constants.running_order_times.AKC.obedience.wc_open,
      [Constants.dog_class_element_level.wc_utility]:
        Constants.running_order_times.AKC.obedience.wc_utility,
      [Constants.dog_class_element_level.udx]:
        Constants.running_order_times.AKC.obedience.udx,
    },
    [Constants.show_type.scentwork]: {
      [Constants.dog_class_element.scentwork_container]: {
        [Constants.dog_class_element_level.novice_a]: 2.5,
        [Constants.dog_class_element_level.novice_b]: 2.5,
        [Constants.dog_class_element_level.scentwork_advanced]: 3,
        [Constants.dog_class_element_level.scentwork_excellent]: 4,
        [Constants.dog_class_element_level.scentwork_master]: 5,
      },
      [Constants.dog_class_element.scentwork_interior]: {
        [Constants.dog_class_element_level.novice_a]: 2.5,
        [Constants.dog_class_element_level.novice_b]: 2.5,
        [Constants.dog_class_element_level.scentwork_advanced]: 3,
        [Constants.dog_class_element_level.scentwork_excellent]: 6.5,
        [Constants.dog_class_element_level.scentwork_master]: 8,
      },
      [Constants.dog_class_element.scentwork_exterior]: {
        [Constants.dog_class_element_level.novice_a]: 2.5,
        [Constants.dog_class_element_level.novice_b]: 2.5,
        [Constants.dog_class_element_level.scentwork_advanced]: 3,
        [Constants.dog_class_element_level.scentwork_excellent]: 4,
        [Constants.dog_class_element_level.scentwork_master]: 5,
      },
      [Constants.dog_class_element.scentwork_buried]: {
        [Constants.dog_class_element_level.novice_a]: 2.5,
        [Constants.dog_class_element_level.novice_b]: 2.5,
        [Constants.dog_class_element_level.scentwork_advanced]: 3,
        [Constants.dog_class_element_level.scentwork_excellent]: 4,
        [Constants.dog_class_element_level.scentwork_master]: 5,
      },
      [Constants.dog_class_element.scentwork_handler_disc]: {
        [Constants.dog_class_element_level.novice_a]: 2.5,
        [Constants.dog_class_element_level.novice_b]: 2.5,
        [Constants.dog_class_element_level.scentwork_advanced]: 3,
        [Constants.dog_class_element_level.scentwork_excellent]: 4,
        [Constants.dog_class_element_level.scentwork_master]: 5,
      },
      [Constants.dog_class_element.conformation_non_licensed]: {
        [Constants.dog_class_element_level.scentwork_detective]: 10,
      },
    },
    [Constants.show_type.conformation]: {
      [Constants.dog_class_element_level.akc_4_6_month_puppy]: 2.727272727272,
      [Constants.dog_class_element_level.akc_6_9_month_puppy]: 2.727272727272,
      [Constants.dog_class_element_level.akc_9_12_month_puppy]: 2.727272727272,
      [Constants.dog_class_element_level.akc_12_18_month_puppy]: 2.727272727272,
      [Constants.dog_class_element_level.akc_under_12_month_bred_by_exhibitor]: 2.727272727272,
      [Constants.dog_class_element_level.akc_adult_bred_by_exhibitor]: 2.727272727272,
      [Constants.dog_class_element_level.akc_amateur_owner_handler]: 2.727272727272,
      [Constants.dog_class_element_level.akc_american_bred]: 2.727272727272,
      [Constants.dog_class_element_level.akc_open]: 2.727272727272,
      [Constants.dog_class_element_level.akc_best_of_breed]: 2.727272727272,
      [Constants.dog_class_element_level.akc_veteran_6_8_years]: 2.727272727272,
      [Constants.dog_class_element_level.akc_veteran_8_10_years]: 2.727272727272,
      [Constants.dog_class_element_level.akc_veteran_10_12_years]: 2.727272727272,
      [Constants.dog_class_element_level.akc_veteran_7_plus_years]: 2.727272727272,
      [Constants.dog_class_element_level.akc_veteran_8_plus_years]: 2.727272727272,
      [Constants.dog_class_element_level.akc_veteran_13_plus_years]: 2.727272727272,
      [Constants.dog_class_element.junior_showmanship]: 2.727272727272,
      [Constants.dog_class_element.conformation_non_licensed]: {
        [Constants.dog_class_element.akc_sweepstakes]: 2.727272727272,
        [Constants.dog_class_element.akc_futurity]: 2.727272727272,
        [Constants.dog_class_element.akc_sled_dog]: 2.727272727272
      },
    },
  },
};

export const getRunningTimeMinutes = (
  sanctioningClub: string,
  showType: string,
  showElement?: string,
  level?: string
): number => {
  //
  return (
    ElementRunningTimes[sanctioningClub]?.[showType]?.[level || ""] ??
    ElementRunningTimes[sanctioningClub]?.[showType]?.[showElement || ""]?.[
      level || ""
    ] ??
    0
  );
};
